import SharedTools from './SharedTools';

export default class StringHelper {
  // Two methods to call static method from member method:
  // 1. StringHelp.functionName(). This isn't affacted by inheritance. The functionName() in the super class is always called, even if sub-class has an overriding one.
  // 2. this.constructor.functionName(). This support inheritance, in case the functionName() is overridden by the sub-class.
  constructor() {
  }

  static isString(originalString) {
    return typeof originalString === 'string';
  }

  static isEmpty(originalString) {
    return StringHelper.isString(originalString) && !/\S/.test(originalString);
  }

  static hasChinese(originalString) {
    return StringHelper.isString(originalString) && !!originalString.match(/[\u4e00-\u9faf\u3400-\u4dbf]/);
  }

  // "ABCDEFG" -> "ABCD..."
  static lengthLimit(originalString, lengthLimit, withEllipsis = true) {
    if (!StringHelper.isString(originalString) || lengthLimit <= 0 || originalString.length <= lengthLimit) { return originalString; }

    let newString = originalString.substring(0, lengthLimit);
    if (withEllipsis) {
      const TARGET_SCORE = 3,
        CHINESE_CHARACTER_SCORE = 3,
        ENGLISH_CHARACTER_SCORE = 1;
      let score = 0;
      while (score < TARGET_SCORE && newString.length > 0) {
        if (StringHelper.hasChinese(newString.substring(newString.length - 1))) { score += CHINESE_CHARACTER_SCORE; } else { score += ENGLISH_CHARACTER_SCORE; }
        newString = newString.slice(0, -1);
      }
      newString += '...';
    }
    return newString;
  }


  // "2016-12-07T08:03:08.770Z" -> Wed Dec 07 2016 16:03:08 GMT+0800 (CST)
  // "2016-12-07 08:03:08" -> Wed Dec 07 2016 08:03:08 GMT+0800 (CST)
  static toDate(dateString) {
    if (!StringHelper.isString(dateString)) { return null; }

    let timeStamp = Date.parse(dateString);
    if (isNaN(timeStamp)) {
      const dateStringIOSFormate = dateString.replace(/-/g, '/');
      timeStamp = Date.parse(dateStringIOSFormate);
      if (isNaN(timeStamp)) // other case: invalid string
      { return null; }
    }

    return new Date(timeStamp);
  }

  static Base64() {
    // private property
    const _keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

    // public method for encoding
    this.encode = function (input) {
      let output = '';
      let chr1,
        chr2,
        chr3,
        enc1,
        enc2,
        enc3,
        enc4;
      let i = 0;
      input = this._utf8_encode(input);
      while (i < input.length) {
        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);
        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        enc4 = chr3 & 63;
        if (isNaN(chr2)) {
          enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
          enc4 = 64;
        }
        output = output +
            _keyStr.charAt(enc1) + _keyStr.charAt(enc2) +
            _keyStr.charAt(enc3) + _keyStr.charAt(enc4);
      }
      return output;
    };
    // private method for UTF-8 encoding
    this._utf8_encode = function (string) {
      string = string.replace(/\r\n/g, '\n');
      let utftext = '';
      for (let n = 0; n < string.length; n++) {
        const c = string.charCodeAt(n);
        if (c < 128) {
          utftext += String.fromCharCode(c);
        } else if ((c > 127) && (c < 2048)) {
          utftext += String.fromCharCode((c >> 6) | 192);
          utftext += String.fromCharCode((c & 63) | 128);
        } else {
          utftext += String.fromCharCode((c >> 12) | 224);
          utftext += String.fromCharCode(((c >> 6) & 63) | 128);
          utftext += String.fromCharCode((c & 63) | 128);
        }
      }
      return utftext;
    };
  }

  static semesterToString(gradeNumber, semesterNumber = null) {
    const CHINESE_NUMBER = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
    const SEMESTER_NUMBER = ['全', '上', '下'];

    if (semesterNumber) { return `${CHINESE_NUMBER[gradeNumber]}年级(${SEMESTER_NUMBER[semesterNumber % 10]})`; }
    return `${CHINESE_NUMBER[gradeNumber]}年级`;
  }


  static addRoleName(role, name) {
    if (role === 'teacher' || role === 'Teacher') {
      if (/^[\u4E00-\u9FA5]+$/.test(name)) { // 全中文
        const nameList = ['欧阳', '太史', '端木', '上官', '司马', '东方', '独孤', '南宫', '万俟', '闻人', '夏侯', '诸葛', '尉迟', '公羊', '赫连', '澹台', '皇甫', '宗政', '濮阳', '公冶', '太叔', '申屠', '公孙', '慕容', '仲孙', '钟离', '长孙', '宇文', '司徒', '鲜于', '司空', '闾丘', '子车', '亓官', '司寇', '巫马', '公西', '颛孙', '壤驷', '公良', '漆雕', '乐正', '宰父', '谷梁', '拓跋', '夹谷', '轩辕', '令狐', '段干', '百里', '呼延', '东郭', '南门', '羊舌', '微生', '公户', '公玉', '公仪', '梁丘', '公仲', '公上', '公门', '公山', '公坚', '左丘', '公伯', '西门', '公祖', '第五', '公乘', '贯丘', '公皙', '南荣', '东里', '东宫', '仲长', '子书', '子桑', '即墨', '达奚', '褚师', '吴铭']; // 现存的复姓

        name = name.replace("老师","");
        const familyname = name.substr(0, 1);
        const familySurname = name.substr(0, 2);

        name = `${familyname}老师`;
        nameList.forEach((surname) => {
          if (familySurname === surname) {
            name = `${familySurname}老师`;
          }
        });

        if (familyname == '小' && familySurname.length > 1) {
          name = familySurname + "老师";
        }
      } else {
        name = (name.indexOf('老师') === -1) ? `${name}老师` : name;
      }
    } else if (role === 'parent' || role === 'Parent') {
      name = (name.indexOf('家长') === -1) ? `${name}家长` : name;
    }
    return name;
  }
}



// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/lib/StringHelper.js